(function() {
  'use strict';

  angular.module('ringbaPortal').component('hoverableExternalLink', {
    bindings: {
      externalLinkPath: '@',
      parentSelector: '@'
    },
    controller: HoverableExternalLinkController,
    controllerAs: 'vm',
    transclude: true,
    templateUrl: '/scripts/shared/components/hoverable-external-link/hoverable-external-link.view.html'
  });

  function HoverableExternalLinkController(
  ) {
    'ngInject';

    const vm = this;

    vm.onFieldHover = onFieldHover;

    function onFieldHover($event) {
      const scrollTop = document.documentElement.scrollTop;
      const element = $event.target.getBoundingClientRect();
      const top = element.top;
      const height = element.height;
      const finalLeftPosition = $event.pageX - document.documentElement.getBoundingClientRect().left - 50;
      const existingTooltipElement = document.querySelector('.tooltip');

      _appendMouseLeaveParent($event);

      if (existingTooltipElement) {
        _positionTooltipElement(
          existingTooltipElement,
          finalLeftPosition,
          _getTopPosition(top, scrollTop, height)
        );
        return;
      }

      document.body.appendChild(_buildTooltipElement(
        finalLeftPosition,
        _getTopPosition(top, scrollTop, height),
        true
      ));
    }

    function _appendMouseLeaveParent($event) {
      const closestParent = $event.target.closest(vm.parentSelector);

      if (closestParent) {
        closestParent.addEventListener('mouseleave', function onMouseLeaveHandler(e) {
          _hideTooltip(e);
        });
      }
    }

    function _hideTooltip(e) {
      if ((e.relatedTarget != null) && (e.relatedTarget.classList.contains('tooltip-inline-new-tab')
          || e.relatedTarget.closest('.tooltip-inline-new-tab'))) {
        return;
      }

      const tooltipElement = document.querySelector('.tooltip');

      if (tooltipElement) {
        tooltipElement.style.display = 'none';
      }
    }

    function _buildTooltipElement(x, y) {
      const tooltipElement = document.createElement('div');
      tooltipElement.classList.add('tooltip', 'tooltip-black', 'tooltip-inline-new-tab', 'top', 'fade', 'in');
      tooltipElement.style.left = x + 'px';
      tooltipElement.style.top = y + 'px';

      const tooltipArrowElement = document.createElement('div');
      tooltipArrowElement.classList.add('tooltip-arrow');
      tooltipElement.appendChild(tooltipArrowElement);

      const tooltipInnerElement = document.createElement('div');
      tooltipInnerElement.classList.add('tooltip-inner');

      const externalLinkElement = document.createElement('a');
      externalLinkElement.setAttribute('title', 'Open in new tab');
      externalLinkElement.setAttribute('href', vm.externalLinkPath);
      externalLinkElement.setAttribute('target', '_blank');
      externalLinkElement.innerHTML = 'Click to edit';
      externalLinkElement.classList.add('btn-function', 'external-link-btn', 'm-r-5');

      const externalLinkIconElement = document.createElement('i');
      externalLinkIconElement.classList.add('fa', 'fa-original-size', 'fa-external-link', 'm-l-5');

      externalLinkElement.appendChild(externalLinkIconElement);
      tooltipInnerElement.appendChild(externalLinkElement);
      tooltipElement.appendChild(tooltipInnerElement);

      tooltipElement.addEventListener('mouseleave', function onMouseLeaveHandler(e) {
        e.target.style.display = 'none';
      });

      return tooltipElement;
    }

    function _positionTooltipElement(tooltipElement, x, y) {
      tooltipElement.style.left = x + 'px';
      tooltipElement.style.top = y + 'px';
      tooltipElement.style.display = 'block';
    }

    function _getTopPosition(top, scrollTop, height) {
      const decreaseTopBy = 4;
      return top + scrollTop - (height * 2) - decreaseTopBy;
    }
  }
})();
